export function CreditApplicationsListCtrl ($scope, $state, $translate, workshopAPI, messages, confirm) {

  $scope.tableSettings = {
    columns: [
      {
        field : 'invoice_number',
        header: {
          text: $translate.instant('INVOICE_SPACE.INVOICE_NUMBER')
        },
      },
      {
        field : 'created_on',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'amount',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_APPLICATIONS')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/credit_application_items/count', $scope.invoice.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.reverseCredits = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.REVERSE_CREDIT'))
      .then(function () {
        return workshopAPI.get('/invoice/reverse_credit_applications', $scope.invoice.id);
      }).then(function () {
        messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.CREDITS'), 'success');
        $state.reload();
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.getApplications = ( params ) => {
    return workshopAPI.get('/credit_application_items/index', [
      $scope.invoice.id,
      params.offset,
      params.pageSize,
    ]).then(function (applications) {
      $scope.applications = applications;

      if (applications.length) {
        $scope.$broadcast('open');
      }

      return applications;
    });
  };

  $scope.viewInvoice = function (invoice) {
    $state.go('app.invoice', {
      customer_id: invoice.customer_id,
      id         : invoice.id,
      vehicle_id : invoice.vehicle_id
    });
  };

  $scope.onRowDoubleClick = function (event) {
    workshopAPI.get('/invoice', [event.row.invoice_id]).then(function (invoice) {
      $scope.viewInvoice(invoice);
    });
  };

  $scope.getApplications({ offset: 0, pageSize: 5 });
}